import * as React from 'react';
import { connect } from 'react-redux';

import WorkflowStep from '../../WorkflowStep';
import Fieldset from '../../../components/forms/Fieldset';
import ActivitiesQuestion from './activitiesQuestions/ActivitiesQuestion';
import OtherQuestion from './activitiesQuestions/OtherQuestions';
import ForeignTravelQuestion from './activitiesQuestions/ForeignTravelQuestion';

interface Props {
	questions: any;
	questionnaire: any;
	onQuestionnaireBlur: (e: any) => Promise<any>;
	onQuestionnaireChange: (e: any) => void;
	onForeignTravelAdd: () => void;
	onForeignTravelBlur: (e: any) => void;
	onForeignTravelChange: (e: any, index: number) => void;
	onForeignTravelRemove: (index: number) => void;
	parentNext: (e: any) => void;
	parentPrev: (e: any) => void;
	className?: string;
}
interface State {
	currentStep: number;
}
class ActivitiesForm extends React.Component<Props, State> {
	lastStep = 3;
	constructor(props: Props) {
		super(props);
		this.state = {
			currentStep: this.getStep()
		};
	}
	getStep() {
		var step = parseInt(location.hash.replace('#', ''), 10);
		if (!isNaN(step)) {
			return step;
		}
		return 1;
	}
	componentDidUpdate(prevProps: Props, prevState: State) {
		if (this.state.currentStep !== prevState.currentStep) {
			location.hash = this.state.currentStep.toString();
		}
	}
	prevStep = (e: any) => {
		let currentStep = this.state.currentStep;
		if (currentStep <= 1) {
			this.props.parentPrev(e);
			return;
		} else {
			currentStep--;
			this.setState({ ...this.state, currentStep: currentStep });
		}
	}
	nextStep = (e: any) => {
		let currentStep = this.state.currentStep;
		if (currentStep === this.lastStep) {
			this.props.parentNext(e);
			return;
		} else {
			currentStep++;
			this.setState({ ...this.state, currentStep: currentStep });
		}
	}

	render() {
		const {
			questions,
			questionnaire,
			onQuestionnaireBlur,
			onQuestionnaireChange,
			onForeignTravelRemove,
			onForeignTravelBlur,
			onForeignTravelChange,
			onForeignTravelAdd,
		} = this.props;
		let currentQuestion = null;
		switch (this.state.currentStep) {
			case 1:
				currentQuestion =
					(
						<ActivitiesQuestion
							questions={questions}
							questionnaire={questionnaire}
							onQuestionnaireBlur={onQuestionnaireBlur}
							onQuestionnaireChange={onQuestionnaireChange}
							nextStep={this.nextStep}
							prevStep={this.prevStep}
						/>);
				break;
			case 2:
				currentQuestion =
					(
						<ForeignTravelQuestion
							questions={questions}
							questionnaire={questionnaire}
							onQuestionnaireBlur={onQuestionnaireBlur}
							onQuestionnaireChange={onQuestionnaireChange}
							nextStep={this.nextStep}
							prevStep={this.prevStep}
							onForeignTravelAdd={onForeignTravelAdd}
							onForeignTravelChange={onForeignTravelChange}
							onForeignTravelBlur={onForeignTravelBlur}
							onForeignTravelRemove={onForeignTravelRemove}
						/>
					);
				break;
			default:
			case 3:
				currentQuestion =
					(
						<OtherQuestion
							questions={questions}
							questionnaire={questionnaire}
							onQuestionnaireBlur={onQuestionnaireBlur}
							onQuestionnaireChange={onQuestionnaireChange}
							nextStep={this.nextStep}
							prevStep={this.prevStep}
						/>);
				break;
		}

		return (
			<WorkflowStep
				className={this.props.className}
				title={this.state.currentStep === 1 ? 'Next, we\'d like to know more about how you like to spend your time.' : ''}
			>
				<Fieldset>
					{currentQuestion}
				</Fieldset>
			</WorkflowStep>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		questions: state.question.questions,
	};
}
export default connect(mapStateToProps)(ActivitiesForm);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/create-your-account/ActivitiesForm.tsx